/**
 * When a failed request means the session is over. Mirrors glp-frontend's
 * `resolveUnauthorizedAction` (`apps/glp-frontend/src/lib/auth/session.ts`):
 * any 401 ends the session, except one from the login endpoint, which means
 * bad credentials and is reported by the sign-in form itself.
 */

/** Path of a request URL without origin, query, `/api` prefix or slashes. */
function endpointPath(url: string | undefined): string {
  if (!url) return '';
  let path = url.replace(/^[a-z]+:\/\/[^/]+/i, '');
  const query = path.search(/[?#]/);
  if (query !== -1) path = path.slice(0, query);
  return path
    .replace(/^\/+/, '')
    .replace(/^api\//, '')
    .replace(/\/+$/, '');
}

export function shouldEndSession(
  status: number | undefined,
  requestUrl: string | undefined
): boolean {
  if (status !== 401) return false;
  return endpointPath(requestUrl) !== 'login';
}

/** Pages a signed-out user may be on; never redirect to sign-in from these. */
const PUBLIC_AUTH_PREFIXES = ['/sign-in', '/reset-password'];

export function isPublicAuthPath(pathname: string): boolean {
  return PUBLIC_AUTH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
